import React, { useCallback, useEffect, useState } from 'react';
import './NewTraveler.scss';
import { Form } from 'devextreme-react';
import { ButtonItem, ButtonOptions, GroupItem, Item, Label, RequiredRule } from 'devextreme-react/cjs/form';
import GlobalParams from '../../helpers/GlobalParams';
import notify from 'devextreme/ui/notify';



const NewTraveler = ({ onClosePopup, defaultForm }) => {

  console.log(defaultForm);
  
  const [travelData, setTravelData] = useState(defaultForm);
  
  const [isLoading, setIsLoading] = useState(false);

  // if (isFormLoaded) {
  //   updateRiderStore();
  // }

  const calculateAge = (birthDate) => {
    const currentDate = new Date();
    const birthDateObj = new Date(birthDate);
  
    let age = currentDate.getFullYear() - birthDateObj.getFullYear();
  
    // Check if the birthday has occurred for this year
    if (currentDate.getMonth() < birthDateObj.getMonth() ||
      (currentDate.getMonth() === birthDateObj.getMonth() && currentDate.getDate() < birthDateObj.getDate())) {
      age--;
    }
  
    return age;
  };

  const ClearForm = () => {
    setTravelData(defaultForm);
  }

  const emptyItemConfig = {
    colSpan: 3,
    itemType: 'empty',
  };

  const doSave = useCallback(async (e) => {
    e.preventDefault();
    //console.log(quotationStore.HasDependants);


    //TODO perform the search here
    //console.log('Search clicked. Scheme:', riderStore.scheme_id);
    setIsLoading(true);
    //fetchData(searchStore.scheme_id, searchStore.name);
    //postData(memberStore);
    // Close the pop-up after the search is performed
    ClearForm();
    onClosePopup(travelData);
    
  }, [travelData]);

  return (
    <div>
      <form onSubmit={doSave}>
        <Form
          formData={travelData} onContentReady={ () =>
            {
              console.log("at content ready");
              setTravelData(defaultForm);
            }
          }>
          <GroupItem colCount={1} caption="">
            {/*TravelerName, Age, BirthDate, date_from, date_to, Country*/}

            <Item
              dataField="TravelerName"
              editorType="dxTextBox"
              editorOptions={
                {
                  readOnly:false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      setTravelData((state) => {
                        return ({ ...state, TravelerName: e.value })
                      });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Name is required" />
              <Label text='Name' />
            </Item>

            <Item
                dataField="BirthDate"
                editorType="dxDateBox"
                editorOptions={
                  {
                    displayFormat: "dd/MM/yyyy",
                    onValueChanged: (e) => {
                      if (e.value !== undefined && e.value !== null && e.value !== '') {
                        //console.log(e.value);
                        const anb = calculateAge(e.value);
                        setTravelData((state) => {
                          return ({ ...state, Age: anb})
                        });
                        //console.log(anb);
                        setTravelData((state) => {
                          return ({ ...state, BirthDate: e.value })
                        });
                        
                        // setQuoatationStore((state) => {
                        //   return ({ ...state, date_to: getDateAfterOneYear(e.value) })
                        // });

                      }
                    }
                  }
                }
              >
                <RequiredRule text="Date of Birth is Required is required" />
                <Label text='Date of Birth' />
              </Item>

              <Item
                dataField="Age"
                editorType="dxNumberBox"
                editorOptions={
                  {
                    readOnly: true,
                    format: ",##0.###",
                    // onValueChanged: (e) => {
                    //   if (e.value !== undefined && e.value !== null && e.value !== '') {
                    //     console.log(e.value);
                    //     // setTravelData((state) => {
                    //     //   return ({ ...state, Age: e.value })
                    //     // });
                    //   }
                    // }
                  }
                }
              >
                <RequiredRule message="Age is required" />
                <Label text='Age' />
              </Item>


              <Item
                dataField="date_from"
                editorType="dxDateBox"
                editorOptions={
                  {
                    displayFormat: "dd/MM/yyyy",
                    onValueChanged: (e) => {
                      if (e.value !== undefined && e.value !== null && e.value !== '') {
                        console.log(e.value);
                        //calculate the age of client..

                        setTravelData((state) => {
                          return ({ ...state, date_from: e.value })
                        });
                        // setQuoatationStore((state) => {
                        //return ({ ...state, date_to: getDateAfterOneYear(e.value) })
                        // });

                      }
                    }
                  }
                }
              >
                <RequiredRule text="Trip Departure Date is Required is required" />
                <Label text='Trip Departure Date' />
              </Item>



              <Item
                dataField="date_to"
                editorType="dxDateBox"
                editorOptions={
                  {
                    displayFormat: "dd/MM/yyyy",
                    onValueChanged: (e) => {
                      if (e.value !== undefined && e.value !== null && e.value !== '') {
                        console.log(e.value);
                        //get the date from one year
                        setTravelData((state) => {
                          return ({ ...state, date_to: e.value })
                        });
                        // setQuoatationStore((state) => {
                        //   return ({ ...state, date_to: getDateAfterOneYear(e.value) })
                        // });

                      }
                    }
                  }
                }
              >
                <RequiredRule text="Trip Return Date is Required is required" />
                <Label text='Trip Return Date' />
              </Item>

              <Item
                dataField="Country"
                editorOptions={
                  {
                    onValueChanged: (e) => {
                      if (e.value !== undefined && e.value !== null && e.value !== '') {
                        setTravelData((state) => {
                          return ({ ...state, Country: e.value })
                        });
                      }
                    }
                  }
                }
              >
                <RequiredRule message="Country is required" />
                <Label text='Country' />
              </Item>


            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />


            <ButtonItem
              colSpan={1}
            >
              <ButtonOptions type='default' text="SAVE" icon='save' useSubmitBehavior={true} />
            </ButtonItem>
          </GroupItem>
        </Form>
      </form>
    </div>
  );

}
//export default NewTraveler;
export default React.memo(NewTraveler, () => false);
